import { http } from '@/api/http';

export default {
    /**
     * login 登录
     */
    login(data) {
        return http.post('/login/pc', data, { contentType: 'form' });
    },
    smsLogin(data) {
        return http.post('/login/pc/sms-code', data, { contentType: 'form' });
    },
    jobNoLogin(data) {
        return http.post('/login/pc/job-number', data, { contentType: 'form' });
    },
    faceLogin(data) {
        return http.post('/login/face', data, { contentType: 'file' });
    },
    qrcodeLogin(id, data) {
        return http.get(`/login/qrcode/${id}`, data);
    },
    hrLogin(data) {
        return http.post('/login/cas/nuctech/pc', data, { contentType: 'form' });
    },

    /**
     * account 账号
     */
    getAccountDetail() {
        return http.get(`/account/v2/info`);
    },
    resetUserPwd(id) {
        return http.put(`/account/v2/password/reset/${id}`);
    },
    modifyUserPwd(data) {
        return http.put(`/account/v2/password`, data, { contentType: 'form' });
    },
    ForgetPassword(data) {
        return http.put('/account/v2/password/retrieve', data, { contentType: 'form' });
    },
    // 发送短信验证码
    smsapiSend(data) {
        return http.post('/smsapi/Send', data, { contentType: 'form' });
    },
    bindMobile(data) {
        return http.put(`/account/v2/mobile/bind`, data, { contentType: 'form' });
    },
    untieMobile(data) {
        return http.put(`/account/v2/mobile/untie`, data, { contentType: 'form' });
    },
    mobileOccupation(data) {
        return http.get(`/account/v2/mobile/occupation`, data);
    },

    /**
     * Organisation 组织机构
     */
    //获取组织机构树（新接口）
    getOrganizationTree() {
        return http.get(`/api/Organization/Tree`);
    },
    getOrganizationDetail(id) {
        return http.get(`/api/Organization/${id}`);
    },
    postOrganizationDetail(data) {
        return http.post(`/api/Organization`, data, { contentType: 'form' });
    },
    putOrganizationDetail(id, data) {
        return http.put(`/api/Organization/${id}`, data, { contentType: 'form' });
    },
    deleteOrganizationDetail(id) {
        return http.delete(`/api/Organization/${id}`);
    },
    // 查询组织机构下面的成员
    getOrgMembers(id, options) {
        return http.get(`/api/Organization/members/${id}`, options);
    },
    //组织机构导入
    uploadOrg(fileData) {
        return http.post(`/api/Import/Excel/Organisation`, fileData, { contentType: 'file' });
    },

    /**
     * Dropdown
     */
    // 身份类型
    getUserTypeMenu() {
        return http.get('/api/Dropdown/UserType');
    },
    // 技能等级（初中高..）
    getGradMenu() {
        return http.get('/api/Dropdown/Grad');
    },
    // 岗位
    getPostMenu() {
        return http.get('/api/Dropdown/Post');
    },
    // 学历
    getEducationMenu() {
        return http.get('/api/Dropdown/Education');
    },
    //所属群组
    getGroupMenu() {
        return http.get('/api/Dropdown/group');
    },
    //项目类别
    getProjectTypeMenu() {
        return http.get('/api/Dropdown/StandingBookProjectType');
    },
    //知识类别
    getKnowledgeTypeMenu() {
        return http.get('/api/Dropdown/AssetCategory');
    },
    // 图像来源
    getImageOriginMenu() {
        return http.get('/api/Dropdown/ImageOrigin');
    },
    // 台账来源
    getLedgerOriginMenu() {
        return http.get('/api/Dropdown/StandingBookOrigin');
    },
    getViewCountMenu() {
        return http.get('/api/Dropdown/ImagePerspective');
    },
    //缺席原因
    getAbsenceReason(){
        return http.get('/api/Dropdown/AbsentCause');
    },

    /**
     * Dictionary 字典
     */
    //获取字典列表数据
    getDictionaryQuery(key, data) {
        return http.get(`/api/Dictionary/Query/${key}`, data);
    },
    //修改字典列表数据
    editDictionary(type, id, data) {
        return http.put(`/api/Dictionary/${type}/${id}`, data, { contentType: 'form' });
    },
    //删除字典列表数据
    deletDictionary(type, id) {
        return http.delete(`/api/Dictionary/${type}/${id}`);
    },
    //添加字典列表数据
    addDictionary(type, data) {
        return http.post(`/api/Dictionary/${type}`, data, { contentType: 'form' });
    },
    //获取字典数据
    getDictionary(type, id) {
        return http.get(`/api/Dictionary/${type}/${id}`);
    },
    //获取字典数据
    getImageKpSuperiorTree() {
        return http.get(`/api/Dictionary/ImageKnowledge/SuperiorTree`);
    },

    /**
     * System
     */
    //获取系统信息
    getSystemInfo() {
        return http.get('/api/System');
    },
    //修改保存系统信息
    editSystemInfo(data) {
        return http.put('/api/System', data, { contentType: 'form' });
    },

    changeUserTheme(theme) {
        return http.put(`/api/User/Theme`, theme, { contentType: 'form' });
    },

    /**
     * menu
     */
    querySystemMenus(data) {
        return http.get('/api/Menu/Query', data);
    },
    postSystemMenu(data) {
        return http.post(`/api/Menu`, data, { contentType: 'form' });
    },
    editSystemMenu(id, data) {
        return http.put(`/api/Menu/${id}`, data, { contentType: 'form' });
    },
    deleteMenu(id) {
        return http.delete('/api/Menu/' + id);
    },
    getMenuDetail(id) {
        return http.get(`/api/Menu/${id}`);
    },
    getMenuRoles(id) {
        return http.get(`/api/Menu/Roles/${id}`);
    },
    saveMenuRoles(id, data) {
        return http.put(`/api/Menu/Roles/${id}`, data, { contentType: 'form' });
    },

    /**
     * Role
     */
    querySystemRole(data) {
        return http.get(`/api/Role/Query`, data);
    },
    postSystemRole(data) {
        return http.post(`/api/Role`, data, { contentType: 'form' })
    },
    editSystemRole(id, data) {
        return http.put(`/api/Role/${id}`, data, { contentType: 'form' })
    },
    getRoleDetail(id) {
        return http.get(`/api/Role/${id}`)
    },
    getRoleMember(id) {
        return http.get(`/api/Role/Members/${id}`)
    },
    editRoleMember(id, data) {
        return http.put(`/api/Role/Members/${id}`, data, { contentType: 'form' })
    },
    getRoleMenu(id) {
        return http.get(`/api/Role/Menus/${id}`)
    },
    editRoleMenu(id, data) {
        return http.put(`/api/Role/Menus/${id}`, data, { contentType: 'form' })
    },
    deleteSystemRole(id) {
        return http.delete(`/api/Role/${id}`)
    },

    //移动端配置
    queryMobileLayout() {
        return http.get(`/api/mobilelayout`);
    },
    editMobileLayout(data) {
        return http.put(`/api/mobilelayout`, data, { contentType: 'form' })
    },
    getMoibleOption() {
        return http.get(`/api/mobilelayout/navigations/optional`);
    },
    // 2020/7/8 新的配置接口
    getMobileMenu(data) {
        return http.get(`/api/mobilelayout/getmobilemenu`, data);
    },
    saveMobileMenu(data) {
        return http.put(`/api/mobilelayout/UpdateMobileMenu`, data, { contentType: 'form' })
    },

    /**
     *  部分上传接口
     */
    mergeSimpleUpload(data) {
        return http.post(`${this.simpleUploadURL}/Merge`, data, { contentType: 'form', timeout: 120000 });
    },
    mergeTopicImportUpload(data) {
        return http.post(`${this.topicImportUploadURL}/Merge`, data, { contentType: 'form' });
    },
    mergeZipUpload(data) {
        return http.post(`${this.zipUploaderURL}/merge`, data, { contentType: 'form' });
    },
    uploadQuillImage(data) {
        return http.post(this.fileUploadURL + '/Avatar', data, { contentType: 'file', noShowError: true });
    },
    // 危险品证书上传接口
    uploadCertificateImage(data) {
        return http.post(this.fileUploadURL + '/certificate', data,{ contentType: 'file', noShowError: true });
    },

    /**
     * Certificate 证书
     */
    // 证书管理
    addCert(data) {
        return http.post('/api/Certificate', data);
    },
    deleteCertificate(id) {
        return http.delete(`/api/Certificate/${id}`);
    },
    editCertificate(id, data) {
        return http.put(`/api/Certificate/${id}`, data, { contentType: 'form' });
    },
    getCertificateById(id) {
        return http.get(`/api/Certificate/${id}`);
    },
    getCertificateQuery(data) {
        return http.get('/api/Certificate/Query', data);
    },
    getCertificateQueryByUser(data) {
        return http.get('/api/Certificate/ByUser', data, );
    },
    addCertificateDetail(data) {
        return http.post('/api/Certificate/Detail', data, { contentType: 'form' });
    },
    deleteCertificateDetail(id) {
        return http.delete(`/api/Certificate/Detail/${id}`);
    },
    editCertificateDetail(id, data) {
        return http.put(`/api/Certificate/Detail/${id}`, data, { contentType: 'form' });
    },
    getCertificateDetail(id) {
        return http.get(`/api/Certificate/Detail/${id}`);
    },
    getCertTypesMenu() {
        return http.get(`/api/Dropdown/${'CertType'}`);
    },
    certImport(certType, fileData) {
        return http.post(`/api/Import/Excel/${certType}`, fileData, { contentType: 'file', timeout: 60000, noShowError: true });
    },
    //删除证书图片
    deleteCertPhoto(id) {
        return http.delete(`/api/Certificate/photo/${id}`);
    },

    /**
     * Notification 消息盒子
     */
    getNoticeLongTask(data) {
        return http.get('/api/Notification/Query/LongTask', data);
    },
    getUnAcknowledgeCount(data) {
        return http.get('/api/Notification/GetUnAcknowledgeCount', data);
    },
    confirmNotification(id) {
        return http.put(`/api/Notification/Acknowledge/${id}`);
    },
    deleteNotification(data) {
        return http.delete('/api/Notification', data, { contentType: 'form' });
    },

    /**
     * real-name 实名认证
     */
    getRealNameDetail() {
        return http.get('/api/real-name/id-card');
    },
    getRealNameDisclaimer() {
        return http.get('/api/real-name/id-card/disclaimer');
    },
    postRealNameBasic(data) {
        return http.post('/api/real-name/id-card/basic-data', data, { contentType: 'form' });
    },
    postRealNameImage(data) {
        return http.post('/api/real-name/id-card/image', data, { contentType: 'file' });
    },
    uploadLivenessVideo(data) {
        return http.post('/api/real-name/id-card/liveness/video', data, { contentType: 'file' });
    },

    /**
     * 培训主题
     */
    getTrainSpecial() {
        return http.get('/api/Dictionary/Query/TrainingSpecial');
    },
    getTrainSpecialDetail(id) {
        return http.get(`/api/Dictionary/Query/TrainingSpecial/${id}`);
    },
    postTrainSpecial(data) {
        return http.post('/api/Dictionary/TrainingSpecial', data);
    },
    editTrainSpecial(id, data) {
        return http.put(`/api/Dictionary/TrainingSpecial/${id}`, data);
    },
    deleteTrainSpecial(id) {
        return http.delete(`/api/Dictionary/TrainingSpecial/${id}`);
    },
    getTrainSpecialCover() {
        return http.get('/api/Dictionary/GetSpecialDefaultImage');
    },
    getTrainSpecialTab(data) {
        return http.get('/api/Training/TrainingSpecialByPc', data);
    },
};
